export * from './baidu/angulartics2-baidu-analytics';
export * from './ga/angulartics2-ga';
export * from './gtm/angulartics2-gtm';
export * from './kissmetrics/angulartics2-kissmetrics';
export * from './mixpanel/angulartics2-mixpanel';
export * from './piwik/angulartics2-piwik';
export * from './segment/angulartics2-segment';
export * from './facebook/angulartics2-facebook';
export * from './appinsights/angulartics2-appinsights';
export * from './hubspot/angulartics2-hubspot';
export * from './adobeanalytics/angulartics2-adobeanalytics';



//////////////////
// WEBPACK FOOTER
// ./~/angulartics2/dist/providers/index.js
// module id = 220
// module chunks = 3